import React, { forwardRef, useRef, useEffect, useState } from 'react';
import { type BuyerLayoutProps, type PageLayoutData } from 'app/shop-ui/types';
import { FEATURE_FLAG_KEYS } from 'app/shop-ui/constants';
import clsx from 'clsx';
import { type HEADER_LAYOUT_TYPE } from './define';
import * as SSR from './ssr';
import './Header.scss';

interface HeaderProps extends BuyerLayoutProps<PageLayoutData> {
    children: React.ReactNode;
    isEditingMode?: boolean;
}

export const Header = forwardRef<HTMLDivElement, HeaderProps>((props, ref) => {
    const { children, isEditingMode, __ssr, isBuyer } = props;

    const [hydrated, setHydrated] = useState(false);

    const headerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setHydrated(true);
    }, []);

    if (!hydrated && isBuyer) {
        const headerRootId = __ssr?.layout.layout[0].id;

        const layoutStyle = __ssr?.layout.style[headerRootId];

        if (!layoutStyle) {
            return null;
        }

        const presetStyle = {
            type: layoutStyle[FEATURE_FLAG_KEYS.HEADER_LAYOUT] as HEADER_LAYOUT_TYPE,
            gap: layoutStyle[FEATURE_FLAG_KEYS.GRID_GAP],
            backgroundColor: layoutStyle[FEATURE_FLAG_KEYS.BACKGROUND_COLOR],
            paddingTop: layoutStyle[FEATURE_FLAG_KEYS.PADDING_TOP],
            paddingBottom: layoutStyle[FEATURE_FLAG_KEYS.PADDING_BOTTOM],
            paddingLeft: layoutStyle[FEATURE_FLAG_KEYS.PADDING_LEFT],
            paddingRight: layoutStyle[FEATURE_FLAG_KEYS.PADDING_RIGHT],
            minHeight: layoutStyle[FEATURE_FLAG_KEYS.MIN_HEIGHT],
        };

        return (
            <header>
                <div className="header">
                    <SSR.Header {...presetStyle} />
                </div>
            </header>
        );
    }

    return (
        <header
            ref={headerRef}
            className={clsx('header-container', {
                'header-container--editing': isEditingMode,
            })}
            data-section-header
            data-shop-component-header
            data-layout-root
        >
            <div className="header" ref={ref}>
                {children}
            </div>
        </header>
    );
});

Header.displayName = 'Header';
